/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvoiceVersionInfo } from './';
import {
    InvoiceVersionInfoFromJSON,
    InvoiceVersionInfoFromJSONTyped,
    InvoiceVersionInfoToJSON,
} from './';
import type { ReferralPaymentStatus } from './';
import {
    ReferralPaymentStatusFromJSON,
    ReferralPaymentStatusFromJSONTyped,
    ReferralPaymentStatusToJSON,
} from './';
import type { ReferredProjectDeliverableTaxResource } from './';
import {
    ReferredProjectDeliverableTaxResourceFromJSON,
    ReferredProjectDeliverableTaxResourceFromJSONTyped,
    ReferredProjectDeliverableTaxResourceToJSON,
} from './';
import type { ReferredProjectDeliverableTransactionResource } from './';
import {
    ReferredProjectDeliverableTransactionResourceFromJSON,
    ReferredProjectDeliverableTransactionResourceFromJSONTyped,
    ReferredProjectDeliverableTransactionResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferredProjectDeliverableResource
 */
export interface ReferredProjectDeliverableResource {
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    id: string;
    /**
     * Deliverable year
     * @type {number}
     * @memberof ReferredProjectDeliverableResource
     */
    year: number;
    /**
     * Deliverable month
     * @type {number}
     * @memberof ReferredProjectDeliverableResource
     */
    month: number;
    /**
     * Deliverable earning amount
     * @type {number}
     * @memberof ReferredProjectDeliverableResource
     */
    earnings?: number;
    /**
     * URL to use to download the invoice of that deliverable referral
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    invoiceDownloadUrl?: string;
    /**
     * The ID of the invoice of that deliverable referral
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    invoiceId?: string;
    /**
     * 
     * @type {Array<InvoiceVersionInfo>}
     * @memberof ReferredProjectDeliverableResource
     */
    invoiceVersions?: Array<InvoiceVersionInfo>;
    /**
     * The billing entity of that deliverable referral
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    maltBillingEntity?: string;
    /**
     * 
     * @type {ReferralPaymentStatus}
     * @memberof ReferredProjectDeliverableResource
     */
    paymentStatus: ReferralPaymentStatus;
    /**
     * Project's id
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    projectId: string;
    /**
     * Lot id of the deliverable, if it belongs to a cost plus project
     * @type {string}
     * @memberof ReferredProjectDeliverableResource
     */
    projectLotId?: string;
    /**
     * The transactions of that deliverable referral
     * @type {Array<ReferredProjectDeliverableTaxResource>}
     * @memberof ReferredProjectDeliverableResource
     */
    taxes: Array<ReferredProjectDeliverableTaxResource>;
    /**
     * The transactions of that deliverable referral
     * @type {Array<ReferredProjectDeliverableTransactionResource>}
     * @memberof ReferredProjectDeliverableResource
     */
    transactions: Array<ReferredProjectDeliverableTransactionResource>;
}

/**
 * Check if a given object implements the ReferredProjectDeliverableResource interface.
 */
export function instanceOfReferredProjectDeliverableResource(value: object): value is ReferredProjectDeliverableResource {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function ReferredProjectDeliverableResourceFromJSON(json: any): ReferredProjectDeliverableResource {
    return ReferredProjectDeliverableResourceFromJSONTyped(json, false);
}

export function ReferredProjectDeliverableResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredProjectDeliverableResource {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'id': json['id'],
        'year': json['year'],
        'month': json['month'],
        'earnings': json['earnings'] == null ? undefined : json['earnings'],
        'invoiceDownloadUrl': json['invoiceDownloadUrl'] == null ? undefined : json['invoiceDownloadUrl'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'invoiceVersions': json['invoiceVersions'] == null ? undefined : ((json['invoiceVersions'] as Array<any>).map(InvoiceVersionInfoFromJSON)),
        'maltBillingEntity': json['maltBillingEntity'] == null ? undefined : json['maltBillingEntity'],
        'paymentStatus': ReferralPaymentStatusFromJSON(json['paymentStatus']),
        'projectId': json['projectId'],
        'projectLotId': json['projectLotId'] == null ? undefined : json['projectLotId'],
        'taxes': ((json['taxes'] as Array<any>).map(ReferredProjectDeliverableTaxResourceFromJSON)),
        'transactions': ((json['transactions'] as Array<any>).map(ReferredProjectDeliverableTransactionResourceFromJSON)),
    };
}

export function ReferredProjectDeliverableResourceToJSON(value?: ReferredProjectDeliverableResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': value['currencyCode'],
        'id': value['id'],
        'year': value['year'],
        'month': value['month'],
        'earnings': value['earnings'],
        'invoiceDownloadUrl': value['invoiceDownloadUrl'],
        'invoiceId': value['invoiceId'],
        'invoiceVersions': value['invoiceVersions'] == null ? undefined : ((value['invoiceVersions'] as Array<any>).map((v) => InvoiceVersionInfoToJSON(v))),
        'maltBillingEntity': value['maltBillingEntity'],
        'paymentStatus': ReferralPaymentStatusToJSON(value['paymentStatus']),
        'projectId': value['projectId'],
        'projectLotId': value['projectLotId'],
        'taxes': ((value['taxes'] as Array<any>).map((v) => ReferredProjectDeliverableTaxResourceToJSON(v))),
        'transactions': ((value['transactions'] as Array<any>).map((v) => ReferredProjectDeliverableTransactionResourceToJSON(v))),
    };
}

